import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

import { toSignal } from '@angular/core/rxjs-interop';
import { AuthenticationService, BreadcrumbService } from '@core/services';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { HeaderComponent } from 'src/apps/front-office/src/app/features/header.component';

@Component({
  selector: 'fl-fo-root',
  imports: [RouterModule, Toast, HeaderComponent, BreadcrumbModule, ConfirmDialog],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly breadcrumbService = inject(BreadcrumbService);
  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router);
  protected readonly breadcrumbItems = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(null),
      map(() => this.breadcrumbService.getBreadcrumbItems())
    )
  );

  readonly isAuthenticated = toSignal(this.authService.isAuthenticated$);
}
